module.exports = __webpack_public_path__ + "static/media/interactivo2.af770fbc.png";